import { Divider } from '@mui/material';
import { Identifier } from '@okletsplay/core';
import { MatchPlayer } from 'app/interfaces/entity';
import { MatchResultEntity } from 'app/interfaces/entity';
import { MatchResultSummaryCard } from 'modules/matches/components/MatchResultModal/MatchResultSummaryCard';
import React, { Fragment, FC, useMemo } from 'react';

interface MatchResultSummaryProps {
  matchResults: Record<Identifier, MatchResultEntity>;
  players: MatchPlayer[] | undefined;
}

export const MatchResultSummary: FC<MatchResultSummaryProps> = ({ matchResults, players }) => {
  const cardsData = useMemo(() => {
    if (!players) return [];

    return players
      .map((player) => ({
        player: player,
        score: matchResults[player.userId]?.score ?? 0,
        winnings: matchResults[player.userId]?.winnings ?? 0,
      }))
      .sort((left, right) => right.score - left.score);
  }, [matchResults, players]);

  return (
    <>
      {cardsData.map(({ player, score, winnings }, index) => (
        <Fragment key={player.userId}>
          <MatchResultSummaryCard player={player} score={score} winnings={winnings} index={index} />
          {index !== cardsData?.length - 1 && <Divider />}
        </Fragment>
      ))}
    </>
  );
};
